import { create } from 'zustand';

const useSoundStore = create((set) => ({
  // State
  
  playingSounds: [],
   setPlayingSounds: (updater) =>
   set((state) => ({
     playingSounds:
       typeof updater === "function" ? updater(state.playingSounds) : updater,
   })),

  savedCombos: [],
  setSavedCombos: (savedCombos) => set({ savedCombos }),

  playingCombo: null,
  setPlayingCombo: (comboId) => set({ playingCombo: comboId }),

  activeComboId: null,
  setActiveComboId: (comboId) => set({ activeComboId: comboId }),

  resetSignal: false,
  toggleResetSignal: () =>
    set((state) => ({ resetSignal: !state.resetSignal })),
}));

export default useSoundStore;
